export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-torso-191ba8e5776310112abeb5517a276723.svg";